import React from "react";

import {cn} from "@isudio/utils";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from "../../"

export type BreadcrumbItems = {
  href: string;
  label: string;
}

interface PagecrumbProps {
  className?: string;
  breadCrumbs: BreadcrumbItems[];
  gap?: number;
}

const Pagecrumb = React.forwardRef<Element, PagecrumbProps>(
  ({
     className = "breadcrumb",
     breadCrumbs = []
   }
  ) => {
    return (
      breadCrumbs ?
        <Breadcrumb
          className={cn(`${className}`)}>
          <BreadcrumbList className="gap-1 sm:gap-1 text-xs tracking-tight text-pale-white">
            {breadCrumbs.map(({ href, label }, index) => (
              <React.Fragment key={index}>
                <BreadcrumbItem>
                  <BreadcrumbLink className="transition duration-200 hover:text-generic-hover hover:scale-105" href={href}>{label}</BreadcrumbLink>
                </BreadcrumbItem>

                {index < breadCrumbs.length - 1 && <BreadcrumbSeparator><i
                  className="fa-duotone fa-light fa-angle-right"/></BreadcrumbSeparator>}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      : null
    )
  }
);

Pagecrumb.displayName = "Pagecrumb";
export {Pagecrumb};